import React, { FC, useEffect, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';

export interface Props {
  show: boolean;
  link: Category;
  updateSubMenu: () => void;
}

const HeaderNavigationButtonDesktop: FC<Props> = ({ show, link, updateSubMenu }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const navLinkClassNames = useClassNames([
    'flex px-10 items-center cursor-pointer relative h-full ',
    show
      ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[4px] after:bg-orange-500 after:shadow-md'
      : '',
    'hover:bg-orange-100 hover:rounded-t-[6px] hover:before:rounded-t-[6px] hover:before:border-b-none hover:before:absolute hover:before:bottom-0 hover:before:left-0 hover:before:h-full hover:before:w-full hover:before:border-2 hover:before:border-orange-500 hover:before:content-[""]',
    'hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:h-[4px] hover:after:w-full hover:after:bg-orange-500 hover:after:shadow-md hover:after:content-[""]',
  ]);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  if (!isLoaded) return <></>;

  return (
    <button title={link?.name} className={navLinkClassNames}>
      {link?.name}
    </button>
  );
};
export default HeaderNavigationButtonDesktop;
